import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { ValueType } from 'react-select/lib/types';
import { Dispatch } from 'redux';
import { EventVideoViewModel } from 'stageclip-common';

import { createAllEventVideosRequestedAction } from '../../../actions/eventVideosActions';
import { createAllEventParticipantsRequestedAction } from '../../../actions/participantActions';
import { SimpleModalId } from '../../../constants/modalId';
import { getAegisubProcessedDataFromParticipants } from '../../../helpers/aegisubHelper';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import { baseMapDispatchToProps, baseMapStateToProps } from '../../componentBase';

import {
  AegisubDataModal,
  AegisubDataModalDispatchProps,
  AegisubDataModalOwnProps,
  AegisubDataModalStateProps,
} from './aegisubDataModal';

interface AegisubProcessedDataModalStateProps extends AegisubDataModalStateProps {
  eventVideos: EventVideoViewModel[];
}
interface AegisubProcessedDataModalDispatchProps extends AegisubDataModalDispatchProps {
  loadEventsVideos: (c: AegisubProcessedDataModal) => void;
}

class AegisubProcessedDataModal extends AegisubDataModal<AegisubProcessedDataModalStateProps> {
  constructor(props: any) {
    super(SimpleModalId.AegisubProcessedData, props);
    this.state = {
      getDataToCopy: getAegisubProcessedDataFromParticipants,
      text: 'Copy the data here into Aegisub to review the work',
      title: 'Aegisub Processed Data',
    };
  }

  protected dataLoaded(props: any) {
    return super.dataLoaded(props) && props.eventVideos;
  }

  protected async loadData(props: any) {
    await super.loadData(props);

    if (!props.eventVideos) {
      await props.loadEventsVideos(this);
    }
  }

  protected renderFieldsBeforeText() {
    return (
      <>
        <Select
          options={this.props.eventVideos.map(({ id, name }) => ({
            value: id,
            label: name,
          }))}
          onChange={this.eventVideoUpdated}
          placeholder="Please select event video"
        />
      </>
    );
  }

  private eventVideoUpdated = (option: ValueType<{ label: string; value: string }>) => {
    const { value } = option as { label: string; value: string };

    this.setState({
      filteredParticipants: value
        ? this.props.participants.filter(({ eventVideo }) => !!eventVideo && eventVideo.id === value)
        : undefined,
    });
  };
}

function mapStateToProps(
  state: ClippingPlatformState,
  ownProps: AegisubDataModalOwnProps,
): AegisubProcessedDataModalStateProps {
  const event = getItem(state.entities.events, ownProps.eventId);

  return {
    ...baseMapStateToProps(state),
    eventVideos: getAllWithIds(state.entities.eventVideos, event.eventVideos),
    participants: getAllWithIds(state.entities.participants, event.participants),
  };
}

function mapDispatchToProps(
  dispatch: Dispatch,
  ownProps: AegisubDataModalOwnProps,
): AegisubProcessedDataModalDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadEventParticipants: (c: AegisubDataModal) =>
      dispatch(createAllEventParticipantsRequestedAction(ownProps.eventId, c, dispatch)),
    loadEventsVideos: (c: AegisubDataModal) =>
      dispatch(createAllEventVideosRequestedAction(ownProps.eventId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AegisubProcessedDataModal);
